///<reference types="webpack-env" />
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query/react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { auth } from 'utils/auth';
import { errorHandlingMiddleware } from './middleware/errorHandlingMiddleware';
import rootReducer from './reducers';
import { segmentsApi } from './services/segmentsApi';

const loginInfo = auth.checkAuth();

const preloadedState = {
  userDetails: {
    loading: false,
    error: null,
    loggedIn: Boolean(loginInfo.access_token),
    loggedInUser: loginInfo.name,
    avatar_url: loginInfo.avatar_url,
    stores: loginInfo.stores,
    token: loginInfo.access_token,
    role_id: loginInfo.role_id,
    currentStore: loginInfo.currentStore,
  },
};

function configureAppStore() {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      })
        .concat(segmentsApi.middleware)
        .concat(errorHandlingMiddleware),
  });
  setupListeners(store.dispatch);

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
  }

  return store;
}

const store = configureAppStore();

export default store;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export type RootState = ReturnType<typeof rootReducer>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
